<!-- This File shows the account details for a Seller -->
<template>
  <div class="account">
       <!-- Next payment and update credit card -->
       <v-card>
        <v-card-title primary-title>
            <div v-if="subscriptionStatus === 'canceled'">
              Your account is closed. No further charges will be made to your account.
            </div>
            <div v-else-if="cancelAtPeriodEnd">
              Your account will automatically close on  <b>{{ nextInvoiceDate }}</b>.
              Any final charges will be automatically billed before then.
            </div>
            <div v-else>

              <div v-if="inprogress">
                Loading information about next payment...<v-progress-circular indeterminate></v-progress-circular>
              </div>
              <div v-else-if="subscriptionStatus === 'trialing'">
                Your free trial will end on <b>{{freeTrialEndDate}}</b>.
              </div>
              <div v-else-if="numOrders > 0">
                You have {{numOrders}} orders this period. Your next payment of <b>{{nextInvoiceAmount}}</b> will be automatically charged to your
                 credit card on <b>{{ nextInvoiceDate }}</b>.
              </div>
              <div v-else>
                You have {{numOrders}} orders this period. You will not be charged this month unless an order is received before <b>{{ nextInvoiceDate }}</b>.
              </div>

            </div>
        </v-card-title>


        <v-card-actions v-if="cancelAtPeriodEnd && subscriptionStatus !== 'canceled'">
          <v-spacer></v-spacer>
          <v-btn @click="resubscribe" flat color="accent" :loading="inprogress">
            Re-Open Account
            </v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="subscriptionStatus !== 'canceled'">
          <v-spacer></v-spacer>
          <v-btn @click="showUpdateCreditCard = !showUpdateCreditCard" flat color="accent">
            Update Credit Card
            <v-icon >{{showUpdateCreditCard ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-layout row class="heading success--text " v-show="resubscribeSuccess && !cancelAtPeriodEnd">
          <v-spacer></v-spacer>
          Account was updated.
          <v-spacer></v-spacer>

        </v-layout>

        <v-slide-y-transition>

          <v-card-text v-show="showUpdateCreditCard">
            <hr />
            <form action="/updateCard" method="post" id="update-payment-form">

              <div class="subheading">
                Credit or debit card
              </div>
              <v-layout align-center justify-center row fill-height>

                <v-flex creditcard sm10 xs12 id="card-element">
                  <!-- A Stripe Element will be inserted here. -->
                </v-flex>
              </v-layout>

              <!-- Used to display form errors. -->
              <div id="card-errors" class='error--text' role="alert"></div>

              <br />
              <v-layout row>
                <v-spacer></v-spacer>
                <span v-if="locked" class="error--text">This account is locked. You cannot make changes.</span>
                <v-btn v-else type='submit' :disabled="inprogress" class="success" :loading="inprogress">
                  Update Card
                </v-btn>
              </v-layout>
              <v-layout row class="error--text" v-if="errMessage">
                <v-spacer></v-spacer>
                <span>{{ errMessage }}</span>
              </v-layout>
              <v-layout row class="heading success--text " v-if="updateSuccess">
                <v-spacer></v-spacer>
                <span>Payment updated successfully.</span>
              </v-layout>

          </form>
          </v-card-text>
        </v-slide-y-transition>
      </v-card>

</div>

</template>

<script>

import {mapState} from 'vuex'
import utils from '../../../utils.ts'
import config from '../../../config.js'

export default {
  name: 'CreditCard',
  components: {
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      subscriptionID: state => state.admin.data_ro.subscriptionID,
      planName: state => state.admin.data_ro.planName,
      subscriptionStatus: state => state.admin.data_ro.subscriptionStatus,
      cancelAtPeriodEnd: state => state.admin.data_ro.cancel_at_period_end,
      locked: state => state.admin.public_settings.locked,
      endPeriod: state => state.admin.data_ro.endPeriod,
      aid: state => state.admin.userInfo.aid
    }),
    freeTrialEndDate: function () {
      let endPeriod = this.$store.state.admin.data_ro.endPeriod
      if (endPeriod) {
        return utils.formatDate(endPeriod)
      } else {
        return ""
      }
    }

  },
  props: {

  },
  data () {
    return {
      showUpdateCreditCard: false,
      inprogress: false,
      errMessage: null,
      updateSuccess: false,
      resubscribeSuccess: false,
      nextInvoiceAmount: -1,
      nextInvoiceDate: null,
      numOrders: 0,

    }
  },
  mounted: function () {
    const stripe = window.Stripe(config.stripePublishableKey)
    const elements = stripe.elements()

    this.loadNextInvoiceInfo()

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }

    // Create an instance of the card Element.
    var card = elements.create('card', {style: style})

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element')

    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors')
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ''
      }
    })

    // Handle form submission.
    var form = document.getElementById('update-payment-form')
    form.addEventListener('submit', (event) => {
      event.preventDefault()

      this.updateSuccess = false
      this.inprogress = true
      this.errMessage = null
      stripe.createToken(card).then((result) => {
        if (result.error) {
          this.inprogress = false
          // Inform the user if there was an error.
          var errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
        } else {
          // Send the token to your server.
          this.stripeTokenHandler(result.token)
        }
      })
    })
  },
  methods: {
    loadNextInvoiceInfo: async function () {

      this.inprogress = true

      // Special code.
      if (this.aid === 'demokid' || this.aid === 'dan44') {
        const now = Date.now() + (14*24*60*60*1000) // 14 days from now
        this.nextInvoiceAmount = utils.formatCurrency(0 / 100)
        this.nextInvoiceDate = utils.formatDateFromSeconds(now/1000)
        this.numOrders = 0
        this.inprogress = false
        return
      }

      if (this.subscriptionStatus === 'trialing') {
        this.inprogress = false
        return
      }

      try {
        // Now link them and charge the account
        var getUpcomingInvoice = config.getFunctions().httpsCallable('getUpcomingInvoice')
        const rc = await getUpcomingInvoice()

        console.log('RC from getUpcomingInvoice:' + JSON.stringify(rc))

        // If all went well, we got the data
        this.nextInvoiceAmount = utils.formatCurrency(rc.data.amount_remaining / 100)
        this.nextInvoiceDate = utils.formatDateFromSeconds(rc.data.created)
        this.numOrders = rc.data.numOrders
        this.inprogress = false

      } catch (err) {
        console.error('ERROR loading next invoice: ' + JSON.stringify(err))
        this.errMessage = err.message
        this.inprogress = false
      }

    },

    stripeTokenHandler: async function (stripeToken) {
      // This function wll create and charge the account
      console.log('Got the token:' + stripeToken)

      try {
        // Now link them and charge the account
        var updateStripePaymentInfo = config.getFunctions().httpsCallable('updateStripePaymentInfo')
        const rc = await updateStripePaymentInfo(
          {
            stripeToken: stripeToken
          }
        )

        console.log('RC from update:' + JSON.stringify(rc))

        this.inprogress = false

        // If all went well, we're logged in as the kid, go to their account
        this.updateSuccess = true
      } catch (err) {
        console.error('ERROR creating the accounts: ' + JSON.stringify(err))
        this.errMessage = err.message
        this.inprogress = false
      }
    },
    resubscribe: async function () {
      // Remove the flag to unsubscribe at the end of the period

      this.errMessage = null
      this.resubscribeSuccess = false

      this.inprogress = true

      // Call the async function to reset flag
      try {
        const doNotCancelAtEndOfPeriod = config.getFunctions().httpsCallable('doNotCancelAtEndOfPeriod')
        await doNotCancelAtEndOfPeriod()
        this.resubscribeSuccess = true
      } catch (err) {
        console.error('ERROR do not cancel: ' + JSON.stringify(err))
        this.errMessage = err.message
      }
      this.inprogress = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

</style>
